"use client";

import { cn } from "../../cn";

export interface HotspotDotProps {
  /** Vai para o aria-label e o title: é o que a pessoa ouve e lê no hover. */
  readonly label: string;
  readonly onClick: () => void;
  readonly className?: string;
}

/**
 * O ponto piscante que marca "aqui dá para clicar". Nasceu para o modo livre
 * da demo (`/demo`), onde nada indica que a tela replicada responde a clique.
 *
 * O pulso é `animate-ping`, e `motion-reduce` o desliga: para quem pediu menos
 * movimento sobra o anel estático, que ainda marca o lugar.
 */
export function HotspotDot({ label, onClick, className }: HotspotDotProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      title={label}
      className={cn(
        "group relative flex size-6 items-center justify-center rounded-full",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-highlight focus-visible:ring-offset-2 focus-visible:ring-offset-background",
        className,
      )}
    >
      <span
        aria-hidden
        className="absolute inline-flex size-6 rounded-full bg-highlight/70 opacity-75 animate-ping motion-reduce:animate-none"
      />
      <span
        aria-hidden
        className="relative inline-flex size-3 rounded-full bg-highlight ring-2 ring-highlight-foreground/20 transition-transform duration-200 group-hover:scale-125"
      />
    </button>
  );
}
